export default "<p>find-templates works!</p>\r\n"